import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>04-05</p>
        <p>
        {process.env.REACT_APP_SOURCE_URL}
        {process.env.REACT_APP_SOURCE_URL_1}
KP
          Edit <code>src/App.js</code> and save to reload.
          Bapu Is Famous Entity In GTCSYS, Maulik To Enathi Moto Gando Che, Fankebaj
          Main Branch
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

export default App;
